<h2 mat-dialog-title>{{ isExistingContact ? 'Edit Merchant Contact' : 'Add Merchant Contact' }}</h2>

<mat-dialog-content>
  <div>
    <app-textbox
      [label]="'Email address'"
      [type]="TextModes.Email"
      [required]="true"
      [showRequired]="showRequired"
      [(ngModel)]="userFormData.emailAddress"
      (ngModelChange)="checkValidity()"
      [readonly]="isEmailReadonly"
    ></app-textbox>
  </div>

  <ng-container *ngIf="mode !== Mode.CheckEmail">
    <div style="display: flex; align-items: start; gap: 20px">
      <app-textbox
        [label]="'First name'"
        [required]="true"
        [showRequired]="showRequired"
        [(ngModel)]="userFormData.firstName"
        (ngModelChange)="checkValidity()"
        [readonly]="isFieldReadonly"
      ></app-textbox>
      <app-textbox
        [label]="'Last name'"
        [required]="true"
        [showRequired]="showRequired"
        [(ngModel)]="userFormData.lastName"
        (ngModelChange)="checkValidity()"
        [readonly]="isFieldReadonly"
      ></app-textbox>
    </div>

    <div style="display: flex; align-items: start; gap: 20px">
      <app-textbox
        [label]="'Phone'"
        [type]="TextModes.Phone"
        [required]="true"
        [showRequired]="showRequired"
        [(ngModel)]="userFormData.phone"
        (ngModelChange)="checkValidity()"
        [readonly]="isFieldReadonly"
      ></app-textbox>
      <app-textbox
        [label]="'Fax'"
        [type]="TextModes.Phone"
        [required]="false"
        [(ngModel)]="userFormData.fax"
        (ngModelChange)="checkValidity()"
        [readonly]="isFieldReadonly"
      ></app-textbox>
    </div>
    <app-selectbox
      [label]="'Contact Type'"
      [required]="true"
      [options]="contactTypeOptions"
      [multiple]="true"
      [(ngModel)]="userFormData.contactTypes"
      (ngModelChange)="checkValidity()"
    ></app-selectbox>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions>
  <div
    style="display: flex; gap: 20px; justify-content: center; padding: 20px 0px 0px 0px; width: 100%;"
  >
    <button [disabled]="isChecking" class="btn-secondary" style="width: 150px;" (click)="btnCancelClick()">
      Cancel
    </button>
    <button
      class="btn-primary"
      style="width: 150px;"
      [disabled]="!isValid || isChecking"
      (click)="btnRightClick()"
    >
      {{ rightButtonLabel }}
    </button>
  </div>
</mat-dialog-actions>